import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Styles from '../Config/Styles';

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={Styles.FooterStyle.bg}
    >
      <Typography variant="body2">
        © 2025 All Rights Reserved
      </Typography>
    </Box>
  );
};

export default Footer;
